export default function openInNewTab(path: string): void {
  if (!path || !window) return;
  const win = window.open(path, '_blank');
  if (win) win.focus();
}
